import { RouterProvider } from 'react-router-dom';
import { useContext, useEffect } from 'react';

// project imports
import router from './routes';
import ThemeCustomization from './themes';

import RTLLayout from './components/RTLLayout';
import ScrollTop from './components/ScrollTop';
import Metrics from './metrics';

// auth-provider
import SessionContext, { SessionProvider as AuthProvider } from './contexts/SessionContext';

// ==============================|| APP - SIMPLE DEFAULT PAGE ||============================== //

const AppContent = () => {
  const { isLoggedIn, isInitialized } = useContext(SessionContext);
  
  // Debug sessionStorage logging removed
  
  return (
    <RouterProvider router={router} />
  );
};

export default function App() {
  return (
    <>
      <ThemeCustomization>
        <RTLLayout>
          <ScrollTop>
            <AuthProvider>
              <AppContent />
            </AuthProvider>
          </ScrollTop>
        </RTLLayout>
      </ThemeCustomization>
      <Metrics />
    </>
  );
}